import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComRenderComponent } from './com-render/com-render.component';
import { PageComponent } from './page/page.component';
import { BlockTreeNodeComponent } from './block-tree-node/block-tree-node.component';
import { NgxDynamicTemplateModule } from 'ngx-dynamic-template';
import { ZcLoaderModule } from '../zc-loader/zc-loader.module';
@NgModule({
  imports: [
    CommonModule,
    ZcLoaderModule,
    NgxDynamicTemplateModule
  ],
  declarations: [PageComponent, ComRenderComponent, BlockTreeNodeComponent],
  exports: [PageComponent,ComRenderComponent]
})
export class PageRenderModule { }
